module.exports = __webpack_public_path__ + "img/agent_one.00b4e367.webp";